'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@uzh-bf/design-system';
import { faComments, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import Link from 'next/link';
declare global {
  interface Window {
    gotonode: (node: string) => void;
  }
}
function OlatLinkButton(t0) {
  const $ = _c(12);
  const {
    label,
    icon,
    olatNode,
    repositoryEntry
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      comments: faComments,
      questionCircle: faQuestionCircle
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const iconMap = t1;
  const t2 = `https://lms.uzh.ch/url/RepositoryEntry/${repositoryEntry}/CourseNode/${olatNode}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      root: "rounded-full"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== icon) {
    t4 = icon && iconMap[icon] && <Button.Icon icon={iconMap[icon]} />;
    $[2] = icon;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== label) {
    t5 = <Button.Label>{label}</Button.Label>;
    $[4] = label;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <Button className={t3}>{t4}{t5}</Button>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <Link href={t2} target="_top" rel="noopener noreferrer">{t6}</Link>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export default OlatLinkButton;